module.exports = __webpack_public_path__ + "img/np1.03b6f179.png";